import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Pencil, Trash, Plus, X } from "@phosphor-icons/react";
import { toast } from "sonner";

const empty = {
  icon: "Waveform",
  title: { en: "", gr: "" },
  description: { en: "", gr: "" },
  order: 0, active: true,
};

const ICONS = ["Waveform", "Lightning", "Toolbox", "Buildings", "VinylRecord", "MicrophoneStage", "SecurityCamera", "VideoCamera", "WifiHigh", "Headphones"];

export default function AdminServices() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/services").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing.id) await api.put(`/admin/services/${editing.id}`, editing);
      else await api.post("/admin/services", editing);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Save failed"); }
  };

  const del = async (id) => {
    if (!window.confirm("Delete this service?")) return;
    await api.delete(`/admin/services/${id}`); toast.success("Deleted"); load();
  };

  return (
    <div data-testid="admin-services">
      <div className="flex items-center justify-between mb-8">
        <h1 className="display-font text-3xl font-black uppercase">Services</h1>
        <button onClick={() => setEditing({ ...empty })} className="btn-primary"><Plus size={18} weight="bold" /> New</button>
      </div>

      <div className="grid gap-3">
        {items.map((s) => (
          <div key={s.id} className="card-dark p-4 flex items-center gap-4">
            <div className="flex-1">
              <div className="display-font font-bold">{s.title.en}</div>
              <div className="text-sm text-gray-400 mt-1 line-clamp-2">{s.description.en}</div>
              <div className="mono-font text-xs text-gray-500 mt-1">{s.icon} · order {s.order} · {s.active ? "active" : "hidden"}</div>
            </div>
            <button onClick={() => setEditing({ ...s })} className="p-2 hover:text-[#ccff00]"><Pencil size={18} /></button>
            <button onClick={() => del(s.id)} className="p-2 hover:text-[#ff003c]"><Trash size={18} /></button>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <form onSubmit={save} className="bg-[#0a0a0c] border border-[#2a2a35] max-w-2xl w-full p-6">
            <div className="flex justify-between items-center mb-5">
              <h2 className="display-font text-2xl font-bold">{editing.id ? "Edit" : "New"} service</h2>
              <button type="button" onClick={() => setEditing(null)}><X size={20} /></button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <input required placeholder="Title (EN)" className="input-dark" value={editing.title.en} onChange={(e) => setEditing({ ...editing, title: { ...editing.title, en: e.target.value } })} />
              <input placeholder="Title (GR)" className="input-dark" value={editing.title.gr} onChange={(e) => setEditing({ ...editing, title: { ...editing.title, gr: e.target.value } })} />
              <select className="input-dark" value={editing.icon} onChange={(e) => setEditing({ ...editing, icon: e.target.value })}>
                {ICONS.map((i) => <option key={i} value={i}>{i}</option>)}
              </select>
              <input type="number" className="input-dark" value={editing.order} onChange={(e) => setEditing({ ...editing, order: parseInt(e.target.value || 0) })} />
              <textarea placeholder="Description (EN)" className="input-dark sm:col-span-2 min-h-[100px]" value={editing.description.en} onChange={(e) => setEditing({ ...editing, description: { ...editing.description, en: e.target.value } })} />
              <textarea placeholder="Description (GR)" className="input-dark sm:col-span-2 min-h-[100px]" value={editing.description.gr} onChange={(e) => setEditing({ ...editing, description: { ...editing.description, gr: e.target.value } })} />
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={editing.active} onChange={(e) => setEditing({ ...editing, active: e.target.checked })} /> Active</label>
            </div>
            <div className="mt-6 flex gap-3 justify-end">
              <button type="button" className="btn-outline" onClick={() => setEditing(null)}>Cancel</button>
              <button type="submit" className="btn-primary">Save</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
